// import * as React from "react";
import {
  memo,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import Quick from "../../Assests/Dashboard/quickveeLG.png";
import Qlogo from "../../Assests/Images/Qlogo.svg";
import { BiMenu, BiChevronDown, BiSearch, BiStoreAlt } from "react-icons/bi";
// import { useSelector, useDispatch } from "react-redux";
import DownlIcon from "../../Assests/Dashboard/download.svg";
import OnlineData from "../../Assests/Dashboard/online.svg";
import SynkData from "../../Assests/Dashboard/sync.svg";
import DownIcon from "../../Assests/Dashboard/Down.svg";
import Home from "../../Assests/Dashboard/Home.svg";
import HomeNative from "../../Assests/Dashboard/HomeNative.svg";
import downloadIcon from "../../Assests/Dashboard/download.svg";
// import BellIcon from "../../Assests/Dashboard/notification-bell-svgrepo-com.svg";
import pusher from "../../pusher";

import {
  setMenuOpen,
  setIsDropdownOpen,
  setIsStoreActive,
  setIsMobileViewActive,
  setIsOpenedByHover,
  setIsOpenedByIcon,
  pinSidebar,
} from "../../Redux/features/NavBar/MenuSlice";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import UserLogo from "../../Assests/Dashboard/UserLogo.svg";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import AppearancePicker from "../../theme/AppearancePicker";
import ListSubheader from "@mui/material/ListSubheader";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux"; //,localAuthCheck
import InputLabel from "@mui/material/InputLabel";
// import MenuItem from '@mui/material/MenuItem';
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { FaChevronDown } from "react-icons/fa";
import {
  getAuthSessionRecord,
  handleGetStoreRecord,
  getAuthInvalidMessage,
  switchStoreWithCode,
  getUserRecordData,
  getUserDashboardRecord,
  resendOTP,
} from "../../Redux/features/Authentication/loginSlice";
import { display, useMediaQuery } from "@mui/system";
import { useAuthDetails } from "../../Common/cookiesHelper";
import { flushChatbotOnLogout } from "../../utils/flushChatbotOnLogout";
import { clearSession } from "../../Common/sessionLogout";
import {
  Button,
  InputBase,
  styled,
  Tooltip,
  tooltipClasses,
} from "@mui/material";
import { List as VirtualList } from "react-window";
import logoutLogo from "../../Assests/Dashboard/logout.svg";
import userLogo from "../../Assests/Dashboard/userLogoDropDown.svg";
import Config, {
  BASE_URL,
  SYNC_DATA,
  SEND_FOR_APPROVAL,
  MARK_NOTIFICATION_READ,
} from "../../Constants/Config";
import { ciUrl } from "../../Constants/nodeCi";
import axios from "axios";
import { ToastifyAlert } from "../../CommonComponents/ToastifyAlert";
import PasswordShow from "../../Common/passwordShow";
import CircularProgress from "@mui/material/CircularProgress";
import needHelpLogo from "../../Assests/Dashboard/need_help.svg";
// import { useLocation } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import { clearRevenueChart } from "../../Redux/features/Dashboard/Charts/RevenueChartSlice";
import { clearPercentageDiscountChart } from "../../Redux/features/Dashboard/Charts/percentageDiscountChartSlice";
import { clearGrossProfitChart } from "../../Redux/features/Dashboard/Charts/grossProfitChartSlice";
import { clearDiscountChart } from "../../Redux/features/Dashboard/Charts/discountChartSlice";
import { clearSalesCountChart } from "../../Redux/features/Dashboard/Charts/salesCountSlice";
import { clearAvgSaleValueChart } from "../../Redux/features/Dashboard/Charts/avgSaleValueChartSlice";
import { clearAvgItemSaleChart } from "../../Redux/features/Dashboard/Charts/avgItemSaleChartSlice";
import { clearCustomerCountChart } from "../../Redux/features/Dashboard/Charts/customerCountSlice";
import { OTPModal } from "./OTPModal";
import "../../Styles/HeaderWorkspace.css";
import { useQboAttention, describeQboAttention } from "../quickbooks/useQboAttention";
import QuickBooksMark from "../../Assests/QuickBooks/qb-mark.svg";

/** Matches `.qv-app-header-menu__store-option` min-height + vertical margin. */
const STORE_OPTION_ROW_HEIGHT = 58;
const STORE_LIST_MAX_HEIGHT = 360;

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#172033",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 320,
    padding: "8px 10px",
    border: "1px solid var(--qv-bd-a255x255x255x120, rgba(255, 255, 255, 0.12))",
    borderRadius: 8,
    backgroundColor: "#172033",
    boxShadow: "0 10px 28px rgba(15, 23, 42, 0.22)",
    color: "#F8FAFC",
    fontSize: theme.typography.pxToRem(13),
    lineHeight: 1.35,
  },
}));

const StoreSearchInput = memo(function StoreSearchInput({
  isOpen,
  query,
  onQueryChange,
  onClose,
  onNavigateKeyDown,
  activeOptionId,
}) {
  const inputRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;

    const animationFrameId = window.requestAnimationFrame(() => {
      inputRef.current?.focus({ preventScroll: true });
    });

    return () => window.cancelAnimationFrame(animationFrameId);
  }, [isOpen]);

  return (
    <ListSubheader
      role="none"
      className="Searchmarchant qv-app-header-menu__search-row"
      onMouseDown={(event) => {
        // MenuList focuses items on mouse down. Keep the caret in the field.
        event.stopPropagation();
      }}
    >
      <BiSearch
        className="qv-app-header-menu__search-icon"
        aria-hidden="true"
      />
      <InputBase
        className="qv-app-header-menu__search"
        placeholder="Search stores..."
        onChange={(event) => {
          onQueryChange(event.target.value);
        }}
        onMouseDown={(event) => {
          event.stopPropagation();
        }}
        onKeyDown={(event) => {
          // MenuList typeahead calls preventDefault on letter keys, which
          // would block the field and leave the list unfiltered.
          event.stopPropagation();
          if (event.key === "Escape") {
            onClose(event, "escapeKeyDown");
            return;
          }
          onNavigateKeyDown?.(event);
        }}
        value={query}
        inputRef={inputRef}
        inputProps={{
          "aria-label": "Search stores",
          autoComplete: "off",
          role: "combobox",
          "aria-autocomplete": "list",
          "aria-controls": "qv-store-switcher-list",
          "aria-activedescendant": activeOptionId,
          "aria-expanded": isOpen ? "true" : "false",
        }}
      />
    </ListSubheader>
  );
});

StoreSearchInput.muiSkipListHighlight = true;

const StoreOptionRow = memo(function StoreOptionRow({
  index,
  style,
  stores,
  currentMerchantId,
  highlightedIndex,
  onClose,
  onStoreSelect,
}) {
  const item = stores[index];
  if (!item) return null;

  const isCurrentStore =
    item.merchant_id != null &&
    String(item.merchant_id) === String(currentMerchantId);
  // Keyboard focus only — mouse uses existing :hover styles.
  const isHighlighted = highlightedIndex === index;

  return (
    <div style={style}>
      <MenuItem
        id={`qv-store-option-${index}`}
        sx={{ fontFamily: "CircularSTDBook" }}
        className={`qv-app-header-menu__store-option${
          isHighlighted ? " qv-app-header-menu__store-option--active" : ""
        }`}
        selected={isCurrentStore}
        aria-selected={isHighlighted}
        aria-current={isCurrentStore ? "true" : undefined}
        role="option"
        onClick={(event) => {
          onClose(event);
          onStoreSelect(item);
        }}
      >
        <BiStoreAlt
          className="qv-app-header-menu__store-option-icon"
          aria-hidden="true"
        />
        <span className="qv-app-header-menu__store-option-name">
          {item.name ?? ""}
        </span>
        {isCurrentStore && (
          <span className="qv-app-header-menu__store-option-status">
            Current
          </span>
        )}
      </MenuItem>
    </div>
  );
});

const StoreSwitcherMenu = memo(function StoreSwitcherMenu({
  anchorEl,
  stores,
  loginType,
  currentMerchantId,
  onClose,
  onStoreSelect,
}) {
  const [searchText, setSearchText] = useState("");
  // -1 until the user moves with the keyboard — hover must not drive Enter.
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const listRef = useRef(null);
  const highlightedIndexRef = useRef(-1);
  const isOpen = Boolean(anchorEl);
  // Same update as the keystroke. A deferred query lets the field show the
  // typed name while this list keeps rendering the previous stores.
  const handleQueryChange = useCallback((value) => {
    setSearchText(value);
  }, []);

  useEffect(() => {
    if (!isOpen) setSearchText("");
  }, [isOpen]);

  const displayOptions = useMemo(() => {
    const normalizedSearch = searchText.trim().toLowerCase();
    const currentId = String(currentMerchantId ?? "");

    const filtered = stores.filter((item) => {
      if (!item) {
        return false;
      }

      const name = String(item.name ?? "").toLowerCase();
      const merchantId = String(item.merchant_id ?? "").toLowerCase();
      const matchesSearch =
        Boolean(name || merchantId) &&
        (name.includes(normalizedSearch) ||
          merchantId.includes(normalizedSearch));
      const isVisible = loginType === "superadmin" || item.status !== "1";

      return matchesSearch && isVisible;
    });

    // Keep the active store pinned at the top of the list.
    filtered.sort((a, b) => {
      const aCurrent = String(a?.merchant_id ?? "") === currentId ? 0 : 1;
      const bCurrent = String(b?.merchant_id ?? "") === currentId ? 0 : 1;
      return aCurrent - bCurrent;
    });

    return filtered;
  }, [currentMerchantId, loginType, searchText, stores]);

  const listHeight = useMemo(() => {
    if (!displayOptions.length) return 0;
    return Math.min(
      displayOptions.length * STORE_OPTION_ROW_HEIGHT,
      STORE_LIST_MAX_HEIGHT,
    );
  }, [displayOptions.length]);

  highlightedIndexRef.current = highlightedIndex;

  const clearKeyboardHighlight = useCallback(() => {
    highlightedIndexRef.current = -1;
    setHighlightedIndex(-1);
  }, []);

  useEffect(() => {
    clearKeyboardHighlight();
  }, [isOpen, clearKeyboardHighlight]);

  useEffect(() => {
    clearKeyboardHighlight();
    // Windowed rows stay at the previous scroll offset. After a new query
    // that offset can still show non-matching stores.
    const element = listRef.current?.element;
    if (element) element.scrollTop = 0;
  }, [searchText, clearKeyboardHighlight]);

  const scrollKeyboardHighlightIntoView = useCallback((index) => {
    listRef.current?.scrollToRow?.({
      index,
      align: "smart",
    });
  }, []);

  const moveKeyboardHighlight = useCallback(
    (next) => {
      highlightedIndexRef.current = next;
      setHighlightedIndex(next);
      scrollKeyboardHighlightIntoView(next);
    },
    [scrollKeyboardHighlightIntoView],
  );

  const selectHighlighted = useCallback(
    (event) => {
      const index = highlightedIndexRef.current;
      if (index < 0) return;
      const item = displayOptions[index];
      if (!item) return;
      onClose(event);
      onStoreSelect(item);
    },
    [displayOptions, onClose, onStoreSelect],
  );

  const handleNavigateKeyDown = useCallback(
    (event) => {
      if (!displayOptions.length) return;

      switch (event.key) {
        case "ArrowDown": {
          event.preventDefault();
          const current = highlightedIndexRef.current;
          const next =
            current < 0
              ? 0
              : Math.min(current + 1, displayOptions.length - 1);
          moveKeyboardHighlight(next);
          break;
        }
        case "ArrowUp": {
          event.preventDefault();
          const current = highlightedIndexRef.current;
          const next =
            current < 0
              ? displayOptions.length - 1
              : Math.max(current - 1, 0);
          moveKeyboardHighlight(next);
          break;
        }
        case "Home":
          event.preventDefault();
          moveKeyboardHighlight(0);
          break;
        case "End":
          event.preventDefault();
          moveKeyboardHighlight(displayOptions.length - 1);
          break;
        case "Enter":
          // Only after ↑/↓ (or Home/End) — not from mouse hover.
          if (highlightedIndexRef.current < 0) return;
          event.preventDefault();
          selectHighlighted(event);
          break;
        default:
          break;
      }
    },
    [displayOptions.length, moveKeyboardHighlight, selectHighlighted],
  );

  const rowProps = useMemo(
    () => ({
      stores: displayOptions,
      currentMerchantId,
      highlightedIndex,
      onClose,
      onStoreSelect,
    }),
    [
      currentMerchantId,
      displayOptions,
      highlightedIndex,
      onClose,
      onStoreSelect,
    ],
  );

  return (
    <Menu
      anchorEl={anchorEl}
      keepMounted={false}
      autoFocus={false}
      disableAutoFocusItem={true}
      variant="menu"
      open={isOpen}
      onClose={onClose}
      onKeyDown={handleNavigateKeyDown}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      PaperProps={{
        className: "qv-app-header-menu qv-app-header-menu--stores",
        style: {
          marginTop: 8,
        },
      }}
      MenuListProps={{
        className: "qv-app-header-menu__list",
        style: {
          paddingTop: 0,
        },
      }}
    >
      <StoreSearchInput
        isOpen={isOpen}
        query={searchText}
        onQueryChange={handleQueryChange}
        onClose={onClose}
        onNavigateKeyDown={handleNavigateKeyDown}
        activeOptionId={
          highlightedIndex >= 0
            ? `qv-store-option-${highlightedIndex}`
            : undefined
        }
      />
      {displayOptions.length === 0 ? (
        <MenuItem disabled className="qv-app-header-menu__empty">
          No stores found
        </MenuItem>
      ) : (
        <StoreVirtualList
          listRef={listRef}
          listHeight={listHeight}
          rowCount={displayOptions.length}
          rowProps={rowProps}
        />
      )}
    </Menu>
  );
});

/** Keeps MUI MenuList from treating the windowed list as a focusable item. */
function StoreVirtualList({ listRef, listHeight, rowCount, rowProps }) {
  return (
    <VirtualList
      listRef={listRef}
      className="qv-app-header-menu__virtual-list"
      style={{ height: listHeight, width: "100%" }}
      rowCount={rowCount}
      rowHeight={STORE_OPTION_ROW_HEIGHT}
      rowComponent={StoreOptionRow}
      rowProps={rowProps}
      overscanCount={6}
      id="qv-store-switcher-list"
      role="listbox"
    />
  );
}
StoreVirtualList.muiSkipListHighlight = true;

// Cross-tab store switch. The tab that switches stamps the new store here; the
// `storage` event carries it to every other Quickvee tab in the browser and, by
// spec, never fires in the tab that wrote it. The session itself rides in
// cookies, which are already shared, so the other tabs only have to reload.
const ACTIVE_STORE_KEY = "qv_active_store";

export default function Header() {
  const {
    LoginGetDashBoardRecordJson,
    LoginAllStore,
    GetSessionLogin,
    userTypeData,
    inventory_approval,
  } = useAuthDetails();
  const [openModal, setOpenModal] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [isOTPModalOpen, setIsOTPModalOpen] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [otpTimer, setOtpTimer] = useState(0);
  const [trustDevice, setTrustDevice] = useState(false);
  const [pendingStoreSwitch, setPendingStoreSwitch] = useState(null);
  const location = useLocation();
  // useEffect for all when update data in coockie-----------------
  sessionStorage.setItem("location", location.pathname + location.search);
  const [anchorElNotif, setAnchorElNotif] = useState(null);
  const openNotif = Boolean(anchorElNotif);
  const [notifications, setNotifications] = useState([]);
  const {
    id,
    categoryCode,
    code,
    couponsCode,
    dealId,
    pageNumber,
    employeeId,
    stocktakeId,
  } = useParams();
  const [method, setMethod] = useState("pickup");
  const superAdminDetails = Cookies.get("superadmin_details");

  let locationPath = sessionStorage.getItem("location");
  // let locationPath = sessionStorage.getItem("location");
  // useEffect for all when update data in coockie--------------
  const isTablet = useMediaQuery("(max-width:1024px)");
  const isMobileNav = useMediaQuery("(max-width:767px)");
  const dispatch = useDispatch();
  const isMenuOpenRedux = useSelector((state) => state.NavBarToggle.isMenuOpen);
  const isDropdownOpen = useSelector(
    (state) => state.NavBarToggle.isDropdownOpen
  );
  let allStoresData = LoginAllStore?.data2?.stores;
  let storenameCookie =
    LoginGetDashBoardRecordJson !== ""
      ? LoginGetDashBoardRecordJson?.data?.name
      : LoginGetDashBoardRecordJson?.data?.name;
  useEffect(() => {
    setStoreName(storenameCookie);
  }, [LoginGetDashBoardRecordJson]);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const [storename, setStoreName] = useState(storenameCookie);
  const [switchToStoreName, setSwitchToStoreName] = useState({});
  const [anchorElForDropDown, setAnchorElForDropDown] = useState(null);
  const [loading, setLoading] = useState(false);
  const isMobileViewActive = useSelector(
    (state) => state.NavBarToggle.isMobileView
  );

  const handleMenuOpen = (event) => {
    setAnchorElForDropDown(event.currentTarget);
  };

  const handleCloseForDropDown = () => {
    setAnchorElForDropDown(null);
  };
  const handleDropdownToggle = () => {
    // Prefer attribute (source of CSS paint) so rapid clicks stay correct even
    // when Redux is deferred until after the browser paints.
    const currentlyPinned =
      document.documentElement.getAttribute("data-qv-sidebar-pinned") === "1";
    const nextOpen = !currentlyPinned;
    document.documentElement.setAttribute(
      "data-qv-sidebar-pinned",
      nextOpen ? "1" : "0",
    );
    // Defer Redux so Header re-render does not block the CSS pin paint.
    requestAnimationFrame(() => {
      dispatch(
        pinSidebar({
          open: nextOpen,
          isNarrow: isTablet,
        }),
      );
    });
  };
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  // QuickBooks things the merchant must act on: badge on the account menu, link inside it.
  const qboAttention = useQboAttention();
  const handleClick = (event) => {
    // Toggle. A theme switch can leave this menu mounted at opacity 0; a
    // second click on the avatar must dismiss that ghost, not no-op.
    setAnchorEl((current) => (current ? null : event.currentTarget));
  };

  const clearDashboardGraphsSliceData = () => {
    dispatch(clearRevenueChart());
    dispatch(clearPercentageDiscountChart());
    dispatch(clearGrossProfitChart());
    dispatch(clearDiscountChart());
    dispatch(clearSalesCountChart());
    dispatch(clearAvgSaleValueChart());
    dispatch(clearAvgItemSaleChart());
    dispatch(clearCustomerCountChart());
  };

  const handleLogout = () => {
    flushChatbotOnLogout(dispatch);
    clearSession();

    navigate("/login");
    window.location.reload();
    dispatch(setIsStoreActive(false));
    dispatch(getAuthInvalidMessage(""));

    // clear graphs slice data
    clearDashboardGraphsSliceData();
  };

  const handleNavigate = () => {
    navigate("/dashboard");
    handleClose();
  };
  const [isSticky, setIsSticky] = useState(false);

  const handleScroll = () => {
    if (window.pageYOffset > 0) {
      setIsSticky(true);
    } else {
      setIsSticky(false);
    }
  };

  // useEffect(() => {
  //   window.addEventListener("scroll", handleScroll);
  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, []);

  // ---------------store changes ----------
  const locationMappings = [
    {
      paths: [
        `/inventory/category/edit-category/${categoryCode}`,
        "/inventory/category/add",
      ],
      navigateTo: "/inventory/category",
    },
    {
      // Legacy product URLs are retained as aliases, but store changes should
      // always land on the current catalog.
      paths: [
        "/inventory/products/add",
        `/inventory/products/edit/${id}`,
        `/inventory/products/duplicate-product/${id}`,
      ],
      navigateTo: "/inventory/new-products",
    },
    {
      // New products UI — the form is bound to one store's product id, so a
      // store switch has to land on that store's list instead of a record it
      // no longer owns. ?type= on the add route is stripped before the match.
      paths: [
        "/inventory/new-products/add",
        `/inventory/new-products/edit/${id}`,
        `/inventory/new-products/duplicate/${id}`,
      ],
      navigateTo: "/inventory/new-products",
    },
    {
      paths: [
        "/purchase-order/add",
        `/purchase-order/${id}`,
      ],
      navigateTo: "/purchase-order",
    },
    {
      paths: [
        `/stocktake/${pageNumber}/completed/${id}`,
        `/stocktake/${pageNumber}/void/${id}`,
        "/stocktake/AddStocktake",
        `/stocktake/${pageNumber}/UpdateStocktake/${id}`,
        `/stocktake/${pageNumber}`,
      ],
      navigateTo: "/stocktake/1",
    },
    {
      paths: ["/stocktake-app", `/stocktake-app/${stocktakeId}`],
      navigateTo: "/stocktake-app",
    },
    {
      paths: [
        "/inventory/old-vendors/add",
        `/inventory/old-vendors/edit-vendor/${encodeURIComponent(code)}`,
        `/inventory/old-vendors/vendor-details/${encodeURIComponent(code)}`,
      ],
      navigateTo: "/inventory/old-vendors",
    },
    {
      paths: [
        "/inventory/vendors/add",
        `/inventory/vendors/edit-vendor/${encodeURIComponent(code)}`,
        `/inventory/vendors/vendor-details/${encodeURIComponent(code)}`,
      ],
      navigateTo: "/inventory/vendors",
    },
    {
      paths: [
        "/inventory/lottery/add-lottery",
        `/inventory/lottery/update-lottery/${encodeURIComponent(id)}`,
      ],
      navigateTo: "/inventory/lottery",
    },
    {
      paths: [
        "/promotions/mix-and-match/add",
        `/mix-and-match/update/${encodeURIComponent(dealId)}`,
      ],
      navigateTo: "/promotions/mix-and-match",
    },
    {
      paths: ["/coupons/add", `/coupons/edit-coupons/${couponsCode}`],
      navigateTo: "/coupons",
    },
    {
      paths: [
        `/store-reporting/register-activity/register-closures/register-closures-summery`,
        `/store-reporting/register-activity/register-closures/register-closures-transactions`,
        // `/store-reporting/register-activity/register-closures/register-closures-summery`,
        // "/store-reporting/register-activity/register-closures/register-closures-transactions",
        // `/stocktake/UpdateStocktake/${id}`,
      ],
      navigateTo: "/store-reporting/register-activity/register-closures",
    },
    {
      paths: [
        "/customer/addCustomer",
        "/customer/editCustomer",
        `/customer/view-customer`,
        "/customer/view-customer",
      ],
      navigateTo: "/customer",
    },
    {
      paths: [
        "/promotions/product-and-category-discounts/add-edit",
        `/promotions/product-and-category-discounts/add-edit/${id}`,
      ],
      navigateTo: "/promotions/product-and-category-discounts/",
    },
    {
      paths: [
        `/store-reporting/employee-reports/employee-ratings-report/${employeeId}`,
      ],
      navigateTo: "/store-reporting/employee-reports/employee-ratings-report",
    },
  ];

  // Every other Quickvee tab follows the switch made in one of them. This tab
  // remembers its OWN store in a ref: cookies are shared, so by the time the
  // event lands they can already read as the new store, and comparing against
  // them would skip the reload. A tab sat on a single record takes the same
  // locationMappings hop first, so none of them reload into a record the store
  // they just moved to doesn't own.
  const tabStoreIdRef = useRef(
    String(LoginGetDashBoardRecordJson?.data?.merchant_id ?? "")
  );
  const storeSwitchHopRef = useRef(null);
  storeSwitchHopRef.current = {
    locationMappings,
    navigate,
    path: location.pathname,
  };

  useEffect(() => {
    const onStoreSwitchedElsewhere = (event) => {
      if (event.key !== ACTIVE_STORE_KEY || !event.newValue) return;
      let stamp = null;
      try {
        stamp = JSON.parse(event.newValue);
      } catch (e) {
        return;
      }
      const merchantId = String(stamp?.merchantId ?? "");
      if (!merchantId || merchantId === tabStoreIdRef.current) return;
      tabStoreIdRef.current = merchantId;
      const hop = storeSwitchHopRef.current;
      const mapping = hop?.locationMappings?.find((m) =>
        m.paths.includes(String(hop.path || "").split("?")[0])
      );
      if (mapping) hop.navigate(mapping.navigateTo);
      window.location.reload();
    };
    window.addEventListener("storage", onStoreSwitchedElsewhere);
    return () =>
      window.removeEventListener("storage", onStoreSwitchedElsewhere);
  }, []);

  // Countdown timer for OTP resend
  useEffect(() => {
    if (otpTimer <= 0) return;
    const interval = setInterval(() => {
      setOtpTimer((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [otpTimer]);

  const handleOpenOTPModal = (item) => {
    if (item?.merchant_id === LoginGetDashBoardRecordJson?.data?.merchant_id) {
      return;
    }

    // Trigger initial store switch attempt to get OTP
    handleChangeMerchant(item, true);
  }

  const handleResendOTP = async () => {
    // return;
    if (otpTimer > 0 || !pendingStoreSwitch) return;
    try {
      const data = {
        username: GetSessionLogin?.username,
        password: GetSessionLogin.password,
        // login_type: LoginGetDashBoardRecordJson?.login_type,
        merchant_id: pendingStoreSwitch?.merchant_id,
        // employee_id: localStorage.getItem("emp_id") || 0,
        storename: pendingStoreSwitch?.login_store_name,
      };
      await dispatch(resendOTP(data));
      setOtpTimer(30);
      setOtpError("");
    } catch (error) {
      console.error("Error resending OTP:", error);
      setOtpError("Failed to resend OTP. Please try again.");
    }
  };

  const handleOnSubmitOTP = (otp, trustDeviceFlag) => {
    if (!pendingStoreSwitch) return;
    setOtpError("");
    handleChangeMerchant(pendingStoreSwitch, false, otp, trustDeviceFlag);
  }

  // ---------------store changes ----------
  // Both switch paths end here: tell the other tabs, then land on a page that is valid for the new store.
  const finishStoreSwitch = (item) => {
    // Tell the other tabs before this one reloads out from under us.
    try {
      window.localStorage.setItem(
        ACTIVE_STORE_KEY,
        JSON.stringify({
          merchantId: String(item?.merchant_id ?? ""),
          // Switching back and forth would otherwise write the same
          // value twice and fire no event the second time.
          at: Date.now(),
        })
      );
    } catch (e) {
      // storage unavailable — this tab still switches, others won't
    }

    const isIncluded = locationMappings.some((mapping) => {
      if (locationPath && mapping.paths.includes(locationPath.split('?')[0])) {
        navigate(mapping.navigateTo);
        return true;
      }
      return false;
    });

    // If no match is found, navigate to the original locationPath
    if (!isIncluded) {
      let finalNavPath = locationPath;
      try {
        if (locationPath && locationPath.includes("?")) {
          const [path, search] = locationPath.split("?");
          const params = new URLSearchParams(search);
          if (params.has("outlets")) {
            params.set("outlets", String(item?.merchant_id));
            finalNavPath = `${path}?${params.toString()}`;
          }
        }
      } catch (e) {
        console.error("Error updating location path:", e);
      }

      navigate(`${finalNavPath}`);
      // Optionally reload the page if needed
      window.location.reload();
    }
    // navigate(`/dashboard`);
    window.location.reload();
    // navigate(`${locationPath}`);
  };

  // A POS webview session (one-time code login) has no password to re-run create_session with.
  const switchStoreViaCode = (item) => {
    const targetId = String((typeof item === "object" ? item?.merchant_id : item) ?? "").trim();
    if (!targetId || targetId === String(LoginGetDashBoardRecordJson?.data?.merchant_id ?? "")) {
      return;
    }
    setLoading(true);
    dispatch(switchStoreWithCode(targetId))
      .then((result) => {
        if (result?.payload?.status === true && result?.payload?.final_login == 1) {
          finishStoreSwitch({ merchant_id: targetId });
          return;
        }
        ToastifyAlert(result?.payload?.msg || "Could not switch store.", "error");
        setLoading(false);
      })
      .catch(() => {
        ToastifyAlert("Could not switch store.", "error");
        setLoading(false);
      });
  };

  const handleChangeMerchant = (item, isInitialAttempt = false, otp = "", trustDeviceFlag = false) => {
    if (LoginGetDashBoardRecordJson?.login_via_code === 1) {
      switchStoreViaCode(item);
      return;
    }
    // return
    let emp_id = 0;
    if (localStorage.getItem("emp_id")) {
      emp_id = localStorage.getItem("emp_id");
    }
    const data = {
      username: GetSessionLogin?.username,
      password: GetSessionLogin.password,
      login_type: LoginGetDashBoardRecordJson?.login_type,
      merchant_id: item?.merchant_id,
      employee_id: emp_id,
      trust_device: trustDeviceFlag ? "1" : "0",
    };

    // Include OTP if provided
    if (otp) {
      data.otp = otp;
    }

    // Include trust_device flag if checkbox is checked
    // if (trustDeviceFlag) {
    //   data.trust_device = "1";
    // }

    // Include stored device token for trusted device check
    const storedDeviceToken = localStorage.getItem("qv_device_token");
    if (storedDeviceToken) {
      data.device_token = storedDeviceToken;
    }

    setLoading(true);
    // return;
    dispatch(handleGetStoreRecord(data))
      .then((result) => {
        // return
        // OTP required — first time (OTP just sent)
        if (
          result?.payload?.status === true &&
          result?.payload?.otp_required === 1 &&
          isInitialAttempt
        ) {
          setIsOTPModalOpen(true);
          setSwitchToStoreName(item);
          setPendingStoreSwitch(item);
          setOtpError("");
          setOtpTimer(30);
          setTrustDevice(false);
          return;
        }

        // OTP required but invalid/expired
        if (
          result?.payload?.status === false &&
          result?.payload?.otp_required === 1
        ) {
          const msg = result?.payload?.msg || "Invalid or expired OTP";
          setOtpError(msg);
          setIsOTPModalOpen(true);
          setSwitchToStoreName(item);
          setPendingStoreSwitch(item);
          // setOtpTimer(30);
          setTrustDevice(false);
          return;
        }

        // Handle OTP rate limiting errors (e.g., "Please wait X seconds")
        // This happens when user cancels modal and tries again too soon
        if (
          result?.payload?.status === false &&
          isInitialAttempt &&
          result?.payload?.msg &&
          (result?.payload?.msg.toLowerCase().includes("wait") ||
            result?.payload?.msg.toLowerCase().includes("otp"))
        ) {
          const msg = result?.payload?.msg || "Please wait before requesting a new OTP";
          setOtpError(msg);
          setIsOTPModalOpen(true);
          setSwitchToStoreName(item);
          setPendingStoreSwitch(item);
          // Extract timer from message if available, otherwise use default
          const timerMatch = msg.match(/(\d+)\s*seconds?/i);
          // setOtpTimer(timerMatch ? parseInt(timerMatch[1]) : 30);
          setTrustDevice(false);
          setLoading(false);
          return;
        }

        // return;
        if (result?.payload?.status == true) {
          if (result?.payload?.final_login == 1) {
            // Close OTP modal if open
            setIsOTPModalOpen(false);
            setPendingStoreSwitch(null);
            setOtpError("");

            finishStoreSwitch(item);
          } else {
            setLoading(false);
          }
        } else {
          // If OTP modal is open, show error in modal
          if (isOTPModalOpen) {
            const msg = result?.payload?.msg || "Authentication failed";
            setOtpError(msg);
            setLoading(false);
          } else {
            // Otherwise, logout and redirect to login
            // Cookies.remove("loginDetails");
            // Cookies.remove("user_auth_record");
            // Cookies.remove("superadmin_details");
            try {
              // localStorage.removeItem("permissionPresetData");
            } catch (e) { }
            // Cookies.remove('token_data');
            dispatch(getAuthInvalidMessage(result?.payload?.msg));
            navigate("/login");
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        if (isOTPModalOpen) {
          setOtpError("An error occurred. Please try again.");
        }
        console.log(err);
      })
      .finally(() => {
        // if (!isOTPModalOpen || (pendingStoreSwitch && !otpError)) {
        setLoading(false);
        // }
      });
  };
  function renderDashboardDropDown() {
    let localAllStores = [];
    try {
      const raw = localStorage.getItem("AllStore");
      if (raw) {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          localAllStores = parsed;
        }
      }
    } catch (e) {
      localAllStores = [];
    }

    const sourceStores = localAllStores && localAllStores.length > 0;

    if (!sourceStores) {
      handleLogout();
      return;
    }

    return (
      <StoreSwitcherMenu
        anchorEl={anchorElForDropDown}
        stores={localAllStores}
        loginType={userTypeData?.login_type}
        currentMerchantId={LoginGetDashBoardRecordJson?.data?.merchant_id}
        onClose={handleCloseForDropDown}
        onStoreSelect={handleOpenOTPModal}
      />
    );
  }

  const { handleCoockieExpire, getUnAutherisedTokenMessage, getNetworkError } =
    PasswordShow();
  const [loader, setLoader] = useState(false);

  const setupDataState = useSelector(
    (state) => state?.StoreSetupList?.storesetupData
  );

  const checkOrderMethod = (item) => {
    const isPickup = item?.is_pickup === "Yes";
    const isDelivery = item?.is_deliver === "Yes";

    if (isPickup) return "pickup";
    if (isDelivery) return "delivery";

    return "pickup";
  };
  useEffect(() => {
    if (setupDataState) {
      const result = checkOrderMethod(setupDataState);
      setMethod(result);
    }
  }, [setupDataState]);

  let AuthDecryptDataDashBoardJSONFormat = LoginGetDashBoardRecordJson;
  const merchant_id = AuthDecryptDataDashBoardJSONFormat?.data?.merchant_id;
  const SyncData = async (e) => {
    const Syncdata = {
      merchant_id: merchant_id,
      token_id: userTypeData?.token_id,
      login_type: userTypeData?.login_type,
    };
    setLoader(true);

    try {
      const res = await axios.post(BASE_URL + SYNC_DATA, Syncdata, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userTypeData?.token}`,
        },
      });

      const data = await res.data.status;
      const update_message = await res.data.msg;
      if (data === true) {
        ToastifyAlert(update_message, "success");
      } else {
        ToastifyAlert(update_message, "warn");
      }
    } catch (error) {
      if (error?.status == 401 || error?.response?.status === 401) {
        getUnAutherisedTokenMessage();
        handleCoockieExpire();
      } else if (error?.status == "Network Error") {
        getNetworkError();
      }
    }
    setLoader(false);
  };

  const handleSendForApproval = async (e) => {
    const Syncdata = {
      token_id: userTypeData?.token_id,
      login_type: userTypeData?.login_type,
      merchant_id: merchant_id,
      store_name: storename,
    };
    setLoader(true);

    try {
      const res = await axios.post(ciUrl(SEND_FOR_APPROVAL), Syncdata, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${userTypeData?.token}`,
        },
      });

      const data = await res.data.status;
      const update_message = await res.data.message;
      if (data === true) {
        ToastifyAlert(update_message, "success");
      } else {
        ToastifyAlert(update_message, "warn");
      }
    } catch (error) {
      if (error?.status == 401 || error?.response?.status === 401) {
        getUnAutherisedTokenMessage();
        handleCoockieExpire();
      } else if (error?.status == "Network Error") {
        getNetworkError();
      }
    }
    setLoader(false);
  };
  const handleNavigateToNeedHelp = () => [
    // navigate("/users/view/unapprove/need-help"),
    navigate("/need-help"),
  ];
  // Handle notification dropdown
  const handleNotifClick = (event) => {
    setAnchorElNotif(event.currentTarget);
    handleNotificationClick(LoginGetDashBoardRecordJson?.data?.merchant_id);
  };
  const handleNotifClose = () => {
    setAnchorElNotif(null);
  };
  // NOTE: Notification/get_notifications initial fetch removed to save the API
  // call. Existing notifications are no longer loaded on mount; only live
  // notifications pushed via Pusher (below) will appear during the session.

  useEffect(() => {
    if (!merchant_id) return;
    const channel = pusher.subscribe(`store-${merchant_id}`);
    channel.bind("my-event", (data) => {
      setNotifications((prevNotifications) => [
        {
          id: data.message.id,
          merchant_id: data.message.merchant_id,
          message: data.message.message,
          status: data.message.status,
          created_at: data.message.created_at,
          notification_type: data.message.notification_type,
        },
        ...prevNotifications,
      ]);
    });

    return () => {
      channel.unbind_all();
      channel.unsubscribe();
    };
  }, [merchant_id]);

  const handleNotificationClick = async (notification) => {
    // const isPusherNotification =
    //   typeof notification === "string" &&
    //   notification.id.startsWith("pusher-");
    if (notification) {
      try {
        const data = {
          merchant_id: merchant_id,
        };
        await axios.post(BASE_URL + MARK_NOTIFICATION_READ, data, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${userTypeData?.token}`,
          },
        });
        // setNotifications((prev) =>
        //   prev.map((n) =>
        //     n.id === notification.id ? { ...n, status: "read" } : n
        //   )
        // );
        setNotifications((prev) => prev.map((n) => ({ ...n, status: "read" })));
      } catch (error) {
        console.error("Error marking notification as read:", error);
      }
    }
  };
  return (
    <>
      <div
        className={`q_header_section qv-app-header qv-app-header--merchant sticky bg-white border-b-4 border-black ${isSticky ? "sticky-header" : ""
          }`}
      >
        <div className="qv-app-header__bar flex items-center justify-between">
          <div className="qv-app-header__start flex items-center justify-between md:px-4 mx-2">
            <BiMenu
              className="qv-app-header__menu-toggle text-black text-[30px] transition duration-300 ease-in-out cursor-pointer"
              aria-label="Toggle navigation menu"
              title="Toggle navigation menu"
              onClick={(e) => {
                handleDropdownToggle();
              }}
            />

            <Link to="/" className="qv-app-header__brand" title="Quickvee home">
              <img
                src={isTablet ? Qlogo : Quick}
                alt="Logo"
                className={`qv-app-header__logo ${isTablet ? "qv-app-header__logo--mark ml-1 mr-3 md:ml-2" : "qv-app-header__logo--full ml-6"}`}
                width={isTablet ? "40px" : "144px"}
                height={isTablet ? "40px" : "32px"}
              // width={isTablet ? "80%" : "auto"}
              />
            </Link>
            {LoginGetDashBoardRecordJson?.final_login == 1 ? (
              LoginAllStore?.data2?.stores !== undefined ||
                (localStorage.getItem("AllStore") !== "" &&
                  localStorage.getItem("AllStore") !== null) ? (
                <>
                  {(
                    JSON.parse(localStorage.getItem("AllStore")) ||
                    allStoresData
                  ).length > 1 ? (
                    <div className="qv-app-header__store relative flex mx-0 md:mx-4 cursor-pointer store-name-for-android admin_medium">
                      <div className="qv-app-header__store-shell flex lg:text-[20px]">
                        <div
                          className="qv-app-header__store-trigger flex items-center"
                          onClick={handleMenuOpen}
                          aria-haspopup="menu"
                          aria-expanded={
                            anchorElForDropDown ? "true" : undefined
                          }
                          aria-label={`Switch store. Current store: ${storename}`}
                          title={storename}
                        >
                          <BootstrapTooltip
                            placement="right"
                            title={`${storename}`}
                          >
                            <p className="qv-app-header__store-name admin_medium">
                              {storename.length >= 20
                                ? `${storename.slice(0, 17)} ...`
                                : storename}
                            </p>
                          </BootstrapTooltip>
                          <div className="qv-app-header__store-chevron ms-0 md:ms-2">
                            {loading ? (
                              <CircularProgress
                                style={{
                                  color: "var(--qv-tx-000000, #000)",
                                  width: "20px",
                                  height: "20px",
                                }}
                              />
                            ) : (
                              <BiChevronDown
                                className="qv-app-header__chevron-icon"
                                aria-hidden="true"
                              />
                            )}
                          </div>
                          {/* <div
                        className="flex items-center cursor-pointer profile-dropdown-for-android Home-for-android"
                        id="basic-button"
                        aria-controls={open ? "basic-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                      >
                        <img
                          style={{ height: "30px", width: "30px" }}
                          src={Home}
                          alt="icon"
                          className="mx-0 md:mx-2"
                        />
                      </div> */}
                        </div>
                        <div>
                          {/* {(JSON.parse(localStorage.getItem("AllStore"))|| allStoresData).length > 0 ? "true" :"false"} */}
                          {renderDashboardDropDown()}
                        </div>
                      </div>

                      {/* <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">
                      {storename}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={storename}
                      label={storename}
                      // onChange={handleChangeStore}
                    >
                      {

                        JSON.parse(localStorage.getItem("AllStore")) !== "" ||
                        Array.isArray(allStoresData)
                          ? (
                              JSON.parse(localStorage.getItem("AllStore")) ||
                              allStoresData
                            )?.map((result, index) => {
                              return (
                                <MenuItem
                                  onClick={() =>
                                    handleChangeMerchant(result?.merchant_id)
                                  }
                                  value={result?.name}
                                >
                                  {result?.name}
                                </MenuItem>
                              );
                            })
                          : ""
                      }
                  
                    </Select>
                  </FormControl> */}

                      {/* <div
              className="flex items-center ml-6 px-3 py-1 text-black lg:text-[20px] admin_medium cursor-pointer sm:text-[12px] md:text-[15px]"
              onClick={handleDropdownToggle}
            >
              Vape Store
              <img src={DownIcon} alt="" className="w-8 h-10 ml-2" />
            </div>

            
            {showDropdown && (
              <div className="absolute mt-2 bg-white border rounded shadow-lg">
               
                <div className="p-4">
                 
                        <div>Category 1</div>
                  <div>Category 2</div>
                  <div>Category 3</div>
                
                </div>
              </div>
            )} */}
                    </div>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )
            ) : (
              ""
            )}
          </div>

          <div className="qv-app-header__actions flex items-center gap-3">
            {userTypeData?.login_type === "superadmin" && superAdminDetails && (
              <Link
                to="/users/unapprove"
                state={{
                  backToSuperAdmin: true,
                }}
                onClick={() => {
                  // const superAdminDetails = Cookies.get("superadmin_details");
                  try {
                    const prefixesToClear = [
                      "qv_dashboard_selectedOutletIds",
                      "dashboardData",
                    ];
                    for (let i = sessionStorage.length - 1; i >= 0; i--) {
                      const key = sessionStorage.key(i);
                      if (!key) continue;
                      const shouldClear = prefixesToClear.some(
                        (p) => key === p || key.startsWith(`${p}_`)
                      );
                      if (shouldClear) {
                        sessionStorage.removeItem(key);
                      }
                    }
                  } catch (e) {
                    // ignore storage errors
                  }

                  if (superAdminDetails) {
                    Cookies.set("loginDetails", superAdminDetails);
                    Cookies.set("token_data", superAdminDetails);
                  }
                }}
                className="qv-app-header__back-link admin_medium mb-0 text-black sm:text-xs md:text-sm"
                aria-label="Back to Super Admin"
                title="Back to Super Admin"
              >
                Back to Super Admin
              </Link>
            )}

            <div className="qv-app-header__action-cluster flex items-center lg:text-[20px] text-black ml-auto sm:text-xs md:text-sm">
              {/* Download App section */}
              {/* ================================ */}
              {isMobileNav ? (
                ""
              ) : (
                <>
                  {LoginGetDashBoardRecordJson?.final_login == 1 ? (
                    <>
                      {/* <div className="ml-5 flex items-center">
                  <img src={DownlIcon} alt="icon" className="ml-2" />
                  <p className="cursor-pointer ml-2 admin_medium">
                    Download App
                  </p>
                </div> */}

                      {/* Online Store and Sync Data section */}
                      {/* <div
                      className={`cursor-pointer  flex items-center Download-the-Mobile-App-for-android`}
                      style={{
                        marginLeft: isTablet ? "0px" : "clamp(20px, 5vw, 30px)",
                      }}
                    >
                      <img
                        src={downloadIcon}
                        alt="icon"
                        className={`${isTablet ? "" : "ml-2"}`}
                        height="24"
                        width="24"
                      />
                      <p className={`${isTablet ? "" : "ml-2"} admin_medium `}>
                        Download the Mobile App
                      </p>
                    </div> */}
                      {/* Notification bell hidden for now.
                      <div className="qv-app-header__notification-area flex items-center">
                        <div className="qv-app-header__notification-wrap relative">
                          {userTypeData?.login_type === "superadmin" ? (
                            <>
                              <img
                                src={BellIcon}
                                alt="Notifications"
                                className="qv-app-header__notification-icon w-4 h-4 cursor-pointer"
                                id="notif-button"
                                aria-controls={
                                  openNotif ? "notif-menu" : undefined
                                }
                                aria-haspopup="true"
                                aria-expanded={openNotif ? "true" : undefined}
                                title="Notifications"
                                onClick={handleNotifClick}
                              />
                              {notifications.some(
                                (n) => n.status === "unread"
                              ) && (
                                  <span className="qv-app-header__notification-badge absolute top-0 right-0 w-2 h-2 bg-red-500 rounded-full"></span>
                                )}
                            </>
                          ) : (
                            ""
                          )}
                          <Menu
                            id="notif-menu"
                            anchorEl={anchorElNotif}
                            open={openNotif}
                            onClose={handleNotifClose}
                            MenuListProps={{
                              "aria-labelledby": "notif-button",
                              className: "qv-app-header-menu__list",
                            }}
                            PaperProps={{
                              className:
                                "qv-app-header-menu qv-app-header-menu--notifications",
                              style: {
                                width: 250,
                                marginTop: 10,
                                maxHeight: 300,
                                overflowY: "auto",
                              },
                            }}
                          >
                            {notifications.length === 0 ? (
                              <MenuItem
                                disabled
                                className="qv-app-header-menu__empty"
                              >
                                No notifications
                              </MenuItem>
                            ) : (
                              notifications
                                .sort(
                                  (a, b) =>
                                    new Date(b.created_at) -
                                    new Date(a.created_at)
                                )
                                .map((notification) => (
                                  <MenuItem
                                    key={notification.id}
                                    className="qv-app-header-menu__notification"
                                  // onClick={() =>
                                  //   handleNotificationClick(notification)
                                  // }
                                  >
                                    <div style={{ width: "100%" }}>
                                      <div
                                        className={`qv-app-header-menu__notification-message ${notification.status === "unread"
                                          ? "font-bold"
                                          : ""
                                          }`}
                                        style={{
                                          fontSize: "13px",

                                          lineHeight: "1.4",
                                          display: "-webkit-box",
                                          WebkitBoxOrient: "vertical",
                                          WebkitLineClamp: 2,
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "normal",
                                        }}
                                      >
                                        {notification.message || "No message"}
                                      </div>

                                      {notification.message &&
                                        notification.message.length > 100 && (
                                          <div style={{ lineHeight: 1 }}>
                                            <small
                                              className="qv-app-header-menu__view-more"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleNotifClose();
                                                setSelectedNotification(
                                                  notification
                                                );
                                                setOpenModal(true);
                                              }}
                                              style={{
                                                color: "#2563EB",
                                                fontSize: "11px",
                                                cursor: "pointer",
                                                display: "inline-block",
                                              }}
                                            >
                                              View More
                                            </small>
                                          </div>
                                        )}

                                      <small
                                        className="qv-app-header-menu__notification-time"
                                        style={{
                                          fontSize: "11px",
                                          color: "#6B7280",
                                        }}
                                      >
                                        {notification.created_at
                                          ? new Date(
                                            notification.created_at
                                          ).toLocaleString("en-US", {
                                            year: "numeric",
                                            month: "short",
                                            day: "numeric",
                                            hour: "numeric",
                                            minute: "numeric",
                                            second: "numeric",
                                            hour12: true,
                                          })
                                          : " "}
                                      </small>

                                      {notification.notification_type && (
                                        <small
                                          className="qv-app-header-menu__notification-type"
                                          style={{
                                            fontSize: "11px",
                                            color: "#9CA3AF",
                                            display: "block",
                                          }}
                                        >
                                          Type: {notification.notification_type}
                                        </small>
                                      )}
                                    </div>
                                  </MenuItem>
                                ))
                            )}
                          </Menu>
                        </div>
                      </div>
                      */}

                      {/* modal for read more */}

                      {openModal && selectedNotification && (
                        <div
                          className="qv-app-header-notification-modal"
                          onClick={() => setOpenModal(false)}
                        >
                          <div
                            className="qv-app-header-notification-modal__card"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <h4 className="qv-app-header-notification-modal__title">
                              Notification Detail
                            </h4>
                            <p
                              className="qv-app-header-notification-modal__message"
                            >
                              {selectedNotification.message}
                            </p>
                            <button
                              onClick={() => setOpenModal(false)}
                              className="qv-app-header-notification-modal__close"
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      )}

                      <Link
                        to={`${Config.VIEW_STORE_URL}merchant/${LoginGetDashBoardRecordJson?.data?.merchant_id}?orderMethod=${method}`}
                        target="_blank"
                        className="qv-app-header__action qv-app-header__action--online online-store-for-android"
                        aria-label="View online store"
                        title="View online store"
                      >
                        <div
                          className="qv-app-header__action-inner cursor-pointer flex items-center"
                          style={{
                            marginLeft: isTablet
                              ? "0px"
                              : "clamp(5px, 5vw, 10px)",
                          }}
                        >
                          <img
                            src={OnlineData}
                            alt="icon"
                            className={`qv-app-header__action-icon ${isTablet ? "" : "ml-2"}`}
                            height="24"
                            width="24"
                          />
                          <p
                            className={`qv-app-header__action-label ${isTablet ? "" : "ml-2"} admin_medium`}
                          >
                            View Online Store
                          </p>
                        </div>
                      </Link>
                      {userTypeData?.login_type !== "superadmin" &&
                        inventory_approval === "1" ? (
                        <button
                          className="qv-app-header__action qv-app-header__action--primary cursor-pointer send-for-approval-for-android flex items-center syncConatiner"
                          aria-label="Send for approval"
                          title="Send for approval"
                          style={{
                            marginLeft: isTablet
                              ? "0px"
                              : "clamp(20px, 5vw, 40px)",
                          }}
                          onClick={handleSendForApproval}
                        >
                          <CircularProgress
                            color={"inherit"}
                            className={` rotaicions ${loader ? "opacity-1" : "opacity-0"
                              }`}
                            width={18}
                            size={18}
                          />
                          <img
                            src={SynkData}
                            alt="icon"
                            className={`qv-app-header__action-icon syncIcon ${loader ? "opacity-0" : "opacity-1"
                              }`}
                            height="24"
                            width="24"
                          />
                          <p className="qv-app-header__action-label ml-2 admin_medium">
                            Send For Approval
                          </p>
                        </button>
                      ) : (
                        <></>
                        // <button
                        //   className={`cursor-pointer sync-data-for-android ${
                        //     isTablet ? "mx-2" : "mx-5"
                        //   } flex items-center syncConatiner`}
                        //   onClick={SyncData}
                        //   disabled={loader}
                        // >
                        //   <CircularProgress
                        //     color={"inherit"}
                        //     className={` rotaicions ${
                        //       loader ? "opacity-1" : "opacity-0"
                        //     }`}
                        //     width={18}
                        //     size={18}
                        //   />

                        //   <img
                        //     src={SynkData}
                        //     alt="icon"
                        //     className={` syncIcon ${
                        //       loader ? "opacity-0" : "opacity-1"
                        //     }`}
                        //     height="24"
                        //     width="24"
                        //   />
                        //   <p className="ml-2 admin_medium">Sync Data</p>
                        // </button>
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </>
              )}

              {/* ======================================== */}
              <div
                className="qv-app-header__profile-trigger flex items-center cursor-pointer profile-dropdown-for-android"
                id="basic-button"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                aria-label={qboAttention.total > 0 ? `Open account menu (QuickBooks: ${qboAttention.total} item${qboAttention.total === 1 ? "" : "s"} need${qboAttention.total === 1 ? "s" : ""} attention)` : "Open account menu"}
                title={qboAttention.total > 0 ? "Account menu · QuickBooks needs your attention" : "Account menu"}
                onClick={handleClick}
              >
                <img
                  style={{ height: "24px", width: "24px" }}
                  src={UserLogo}
                  alt="icon"
                  className="qv-app-header__profile-icon mx-0 md:mx-2"
                />
                {qboAttention.total > 0 && (
                  <span className="qv-app-header__qbo-badge" aria-hidden="true">
                    {qboAttention.total > 99 ? "99+" : qboAttention.total}
                  </span>
                )}
                {/* <p className="admin_medium">{storename?.slice(0, 1)?.toUpperCase()}</p> */}
                <img
                  src={DownIcon}
                  alt=""
                  className="qv-app-header__profile-chevron"
                  height="24"
                  width="24"
                />
              </div>
              <div
                className="qv-app-header__native-home items-center cursor-pointer profile-dropdown-for-android Home-for-android"
                id="basic-button"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
              >
                <img
                  style={{ height: "30px", width: "30px" }}
                  src={HomeNative}
                  alt="icon"
                  className="qv-app-header__native-home-icon qv-app-header__native-home-icon_new mx-0 md:mx-2"
                />
              </div>
              <Menu
                /* Duration 0: Grow's default "auto" timeout unmounts only after
                   its own timer. A theme switch sets transition:none for a
                   frame, and a close in that window used to leave the modal
                   mounted at opacity 0, still eating clicks. */
                transitionDuration={0}
                PaperProps={{
                  className:
                    "profile-menu-for-android qv-app-header-menu qv-app-header-menu--profile",
                  style: {
                    // width: 150,
                    marginTop: 12,
                  },
                }}
                MenuListProps={{
                  className: "qv-app-header-menu__list",
                  style: {
                    padding: 0,
                  },
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
              >
                {storename && (
                  <MenuItem
                    onClick={handleNavigate}
                    className="qv-app-header-menu__profile-store store-name-link-for-android"
                  >
                    <div className="qv-app-header-menu__row flex justify-items-start items-center store-name-div-for-android">
                      <img src={userLogo} alt="" className="w-6 h-6 mr-2" />
                      {storename}
                    </div>{" "}
                  </MenuItem>
                )}
                {qboAttention.total > 0 && (
                  <MenuItem
                    onClick={() => {
                      handleClose();
                      navigate("/quickbooks");
                    }}
                    className="qv-app-header-menu__qbo"
                  >
                    <div className="qv-app-header-menu__row flex justify-items-start items-center">
                      <img src={QuickBooksMark} alt="" aria-hidden="true" width="21" height="21" className="qv-app-header-menu__qbo-icon" />
                      <span className="qv-app-header-menu__qbo-text">
                        <span className="qv-app-header-menu__qbo-title">QuickBooks</span>
                        <span className="qv-app-header-menu__qbo-sub">{describeQboAttention(qboAttention)}</span>
                      </span>
                      <span className="qv-app-header-menu__qbo-count">
                        {qboAttention.total > 99 ? "99+" : qboAttention.total}
                      </span>
                    </div>
                  </MenuItem>
                )}
                {isMobileNav &&
                  (LoginGetDashBoardRecordJson?.final_login == 1 ? (
                    <>
                      {/* <div className="ml-5 flex items-center">
                  <img src={DownlIcon} alt="icon" className="ml-2" />
                  <p className="cursor-pointer ml-2 admin_medium">
                    Download App
                  </p>
                </div> */}

                      {/* Online Store and Sync Data section */}
                      {/* <MenuItem className="Download-the-Mobile-App-for-android two">
                      <div
                        className={`cursor-pointer flex items-center`}
                        style={{
                          marginLeft: isTablet
                            ? "0px"
                            : "clamp(20px, 5vw, 40px)",
                        }}
                      >
                        <img
                          src={downloadIcon}
                          alt="icon"
                          className={`${isTablet ? "" : "ml-2"}`}
                          height="24"
                          width="24"
                        />
                        <p className={`${isTablet ? "" : "ml-2"}`}>
                          Download the Mobile App
                        </p>
                      </div>
                    </MenuItem> */}
                      <MenuItem className="qv-app-header-menu__mobile-store Download-the-Mobile-App-for-android two">
                        <Link
                          to={`${Config.VIEW_STORE_URL}merchant/${LoginGetDashBoardRecordJson?.data?.merchant_id}?orderMethod=${method}`}
                          target="_blank"
                          className="online-store-link-for-android two"
                        >
                          <div
                            className={`cursor-pointer flex items-center`}
                            style={{
                              marginLeft: isTablet
                                ? "0px"
                                : "clamp(20px, 5vw, 40px)",
                            }}
                          >
                            <img
                              src={OnlineData}
                              alt="icon"
                              className={`${isTablet ? "" : "ml-2"}`}
                              height="24"
                              width="24"
                            />
                            <p className={`${isTablet ? "" : "ml-2"}  `}>
                              View Online Store
                            </p>
                          </div>
                        </Link>
                      </MenuItem>
                      {/* <MenuItem className="send-for-approval-for-android sync-data-for-android two">
                        {userTypeData?.login_type !== "superadmin" &&
                          inventory_approval === "1" ? (
                          <button
                            className={`cursor-pointer  flex items-center syncConatiner send-for-approval-btn-for-android two`}
                            onClick={handleSendForApproval}
                          >
                            <CircularProgress
                              color={"inherit"}
                              className={` rotaicions ${loader ? "opacity-1" : "opacity-0"
                                }`}
                              width={18}
                              size={18}
                            />
                            <img
                              src={SynkData}
                              alt="icon"
                              className={` syncIcon ${loader ? "opacity-0" : "opacity-1"
                                }`}
                            />
                            <p className="ml-2 ">Send For Approval</p>
                          </button>
                        ) : (
                          <>
                            <button
                              className={`cursor-pointer  flex items-center syncConatiner sync-data-btn-for-android two`}
                              onClick={SyncData}
                              disabled={loader}
                            >
                              <CircularProgress
                                color={"inherit"}
                                className={` rotaicions ${loader ? "opacity-1" : "opacity-0"
                                  }`}
                                width={18}
                                size={18}
                              />

                              <img
                                src={SynkData}
                                alt="icon"
                                className={` syncIcon ${loader ? "opacity-0" : "opacity-1"
                                  }`}
                              />
                              <p className="ml-2">Sync Data</p>
                            </button>
                          </>

                        )}
                      </MenuItem> */}
                    </>
                  ) : (
                    ""
                  ))}
                {/* APPEARANCE picker (shared component, see
                    src/theme/AppearancePicker.js). Open to every signed-in
                    role; same gate as App.js applies to the theme. */}
                {Boolean(userTypeData?.login_type) && (
                  <AppearancePicker />
                )}
                <MenuItem
                  onClick={handleClose}
                  className="qv-app-header-menu__help"
                >
                  <div
                    className="qv-app-header-menu__row flex justify-items-start items-center"
                    onClick={handleNavigateToNeedHelp}
                  >
                    <img src={needHelpLogo} alt="" className="w-6 h-6 mr-2" />
                    <p>Need Help</p>
                  </div>
                </MenuItem>
                <MenuItem
                  onClick={handleLogout}
                  className="qv-app-header-menu__logout"
                >
                  {" "}
                  <div className="qv-app-header-menu__row flex justify-items-start items-center">
                    <img src={logoutLogo} alt="" className="w-6 h-6 mr-2" />
                    Logout
                  </div>{" "}
                </MenuItem>
              </Menu>

              {/* </div> */}

              {/* Vertical line separator */}
              <div className="qv-app-header__legacy-divider border-t-3 border-b-2 border-black bg-black mb-16"></div>
            </div>
          </div>
        </div>
      </div>
      <OTPModal
        isOpen={isOTPModalOpen}
        onClose={() => {
          setIsOTPModalOpen(false);
          setPendingStoreSwitch(null);
          setOtpError("");
          setTrustDevice(false);
        }}
        shopName={switchToStoreName?.name}
        onSubmit={handleOnSubmitOTP}
        onResend={handleResendOTP}
        otpTimer={otpTimer}
        errorMessage={otpError}
        isLoading={loading}
      />
    </>
  );
}
